import { CoreIcon } from '../core-icon';
import logoPoweredByAutopassOutlineSVG from '../../assets/logos/logo-powered-by-autopass-outline.svg';
import type { IconProps } from '../core-icon';

export const LogoPoweredByAutopassOutlineIcon = (
  props: Omit<IconProps, 'src'>,
) => {
  return <CoreIcon src={logoPoweredByAutopassOutlineSVG} {...props} />;
};
